import { render, staticRenderFns } from "./ThgBatch.vue?vue&type=template&id=21f497c4&"
import script from "./ThgBatch.vue?vue&type=script&lang=ts&"
export * from "./ThgBatch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports